import '../../index.css';
var styles = {
  "inlineError": "bp_inline_error_module_inlineError--7045a",
  "empty": "bp_inline_error_module_empty--7045a",
  "errorIcon": "bp_inline_error_module_errorIcon--7045a"
};
export { styles as default };